import { LOGIN, LOGOUT, GET_AUTHENTICATED_USER } from '../actions/authentication';
import _ from 'lodash';

const INITIAL_STATE = {
  userId: null,
  loggedInAt: null,
  iat: null,
  aud: null,
  exp: null,
  iss: null,
  sub: null,
  token: null,
  user: {},
};

const parseJwt = token => {
  let base64Url = token.split('.')[1];
  let base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case LOGIN:
      let now = new Date();
      return Object.assign({}, state, {user: _.omit(action.value, 'accessToken'), token: action.value.accessToken, loggedInAt: now.toISOString()}, parseJwt(action.value.accessToken));
    case LOGOUT:
      return Object.assign({}, state, INITIAL_STATE);
    case GET_AUTHENTICATED_USER:
      return Object.assign({}, state, {user: action.value});
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/authentication.js